import styled from 'styled-components';

export const PreferencesListV1Styles = styled.div`
  margin: 0 16px;
`;

export const PreferencesListV1ItemStyles = styled.div<{
  imageSrc: string;
  selected: boolean;
}>`
  padding: 20px;
  border-radius: 16px;
  background: ${(props) => {
    if (props.selected) {
      return `url(${props.imageSrc}), #2D1A55`;
    }
    return `url(${props.imageSrc}), #30283E;`;
  }};
  background-size:
    192px 54px,
    contain;
  background-repeat: no-repeat;
  background-position:
    right -14px center,
    center;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  ${(props) =>
    props.selected &&
    `
      outline: 2px solid var(--Pheon-Light-Main-Accent, #803eff);
      outline-offset: -2px;
    `}
`;
